import { Injectable } from '@angular/core';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { ActivityInternal, Customer, GungModalService } from 'gung-standard';
import { ColmecActivityInternalCreateModalComponent } from '../components/colmec-activity-internal-create-modal/colmec-activity-internal-create-modal.component';
import { ColmecClaimCreateModalComponent } from '../components/colmec-claim/colmec-claim-create-modal/colmec-claim-create-modal.component';
import { Claim } from './colmec-claim.service';
import { ColmecPartnerAgreement } from './colmec-partner-agreements.service';
import { ColmecCreateEditPartnerAgreementModalComponent } from '../components/colmec-create-edit-partner-agreement-modal/colmec-create-edit-partner-agreement-modal.component';
import { ColmecTirePolicyImportModalComponent } from '../components/tire-policy/colmec-tire-policy-import-modal/colmec-tire-policy-import-modal.component';

@Injectable({
  providedIn: 'root'
})
export class ColmecModalService extends GungModalService {
  constructor(protected ngbModal: NgbModal) {
    super(ngbModal);
  }

  openClaimModal(customer: Customer, claim?: Claim, modalOption?: NgbModalOptions): Promise<any> {
    const id = ColmecClaimCreateModalComponent.name;
    const option: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
      // windowClass: 'modal-lg-custom',
      ...modalOption
    };
    const modalRef = this.ngbModal.open(ColmecClaimCreateModalComponent, option);
    modalRef.componentInstance.delegate = this;
    modalRef.componentInstance.customer = customer;
    modalRef.componentInstance.claim = claim;
    this.modalRef.set(id, modalRef);
    return modalRef.result;
  }

  openCreateActivityModal(activity?: ActivityInternal, modalOption?: NgbModalOptions): Promise<any> {
    const id = ColmecActivityInternalCreateModalComponent.name;

    const option: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
      // windowClass: 'modal-lg-custom',
      ...modalOption
    };
    const ref = this.ngbModal.open(ColmecActivityInternalCreateModalComponent, option);
    ref.componentInstance.activity = activity;
    this.modalRef.set(id, ref);
    return ref.result;
  }

  openCreateEditPartnerAgreementModal(partnerAgreement?: ColmecPartnerAgreement, modalOption?: NgbModalOptions): Promise<any> {
    const id = ColmecCreateEditPartnerAgreementModalComponent.name;

    const option: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
      ...modalOption
    };
    const ref = this.ngbModal.open(ColmecCreateEditPartnerAgreementModalComponent, option);
    ref.componentInstance.partnerAgreement = partnerAgreement;
    this.modalRef.set(id, ref);
    return ref.result;
  }

  openTirePolicyImportModal(modalOption?: NgbModalOptions): Promise<any> {
    const id = ColmecTirePolicyImportModalComponent.name;

    const option: NgbModalOptions = {
      backdrop: 'static',
      keyboard: false,
      centered: true,
      size: 'lg',
      ...modalOption
    };
    const ref = this.ngbModal.open(ColmecTirePolicyImportModalComponent, option);
    this.modalRef.set(id, ref);
    return ref.result;
  }
}
